// extracted by mini-css-extract-plugin
module.exports = {"root":"NavMobile_root__1H3sm","background":"NavMobile_background__5jVGN","box":"NavMobile_box__2bsmO","list":"NavMobile_list__bHeki","active":"NavMobile_active__3Oaat"};